/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Suggest_Agent_GapsInputs */



/**
* | output |
* | --- |
* | "Make sure there is at least a 2 frame gap between subtitles" |
*
* @param {Assistant_Suggest_Agent_GapsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_suggest_agent_gaps = /** @type {((inputs?: Assistant_Suggest_Agent_GapsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Suggest_Agent_GapsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assurez-vous qu'il y ait au moins 2 images d'intervalle entre les sous-titres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stellen Sie sicher, dass zwischen den Untertiteln ein Abstand von mindestens 2 Einzelbildern besteht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assicurati che ci sia un intervallo di almeno 2 fotogrammi tra i sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Убедитесь, что между субтитрами есть как минимум 2 кадра.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asegúrese de que haya al menos un espacio de 2 fotogramas entre los subtítulos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确保字幕之间至少有 2 帧的间隔。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕間には少なくとも2フレームの間隔を空けてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सुनिश्चित करें कि उपशीर्षकों के बीच कम से कम 2 फ्रेम का अंतर हो।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Certifique-se de que haja um intervalo de pelo menos 2 quadros entre as legendas.")
	return /** @type {LocalizedString} */ ("Make sure there is at least a 2 frame gap between subtitles")
});